export default function EventSkeleton() {
    return (
        <div className="min-h-screen layout md:max-w-[1220px] animate-pulse">
            <div className="flex flex-col md:flex-row max-w-7xl mx-auto gap-10">
                {/* Left Sidebar Skeleton */}
                <aside className="hidden md:flex flex-col w-full md:w-1/3 lg:w-[30%] sticky top-24 self-start min-h-[500px] gap-4">
                    {/* Poster Image */}
                    <div className="w-full aspect-[11/16] bg-gray-300 rounded-[15px]" />

                    {/* Button Skeleton */}
                    <div className="h-12 w-full rounded-xl bg-gray-200" />

                    {/* Share & Like */}
                    <div className="flex flex-row gap-2 w-full">
                        <div className="h-10 w-10 rounded-full bg-gray-300" />
                        <div className="h-10 w-10 rounded-full bg-gray-300" />
                    </div>
                </aside>

                {/* Right Content Skeleton */}
                <section className="w-full md:w-2/3 space-y-6 mt-24 lg:w-[70%]">
                    <section className="flex flex-col gap-10 lg:gap-20">
                        {/* Divider */}
                        <div className="w-full h-[1px] bg-gray-200" />

                        <div className="flex flex-col gap-4">
                            {/* Mobile Image */}
                            <div className="w-full aspect-[11/16] md:hidden bg-gray-300 rounded-[15px]" />

                            {/* Mobile Actions */}
                            <div className="flex flex-row gap-2 md:hidden mt-4 mb-4">
                                <div className="h-10 w-10 rounded-full bg-gray-300" />
                                <div className="h-10 w-10 rounded-full bg-gray-300" />
                            </div>

                            {/* Title & Description */}
                            <div className="flex flex-col gap-3">
                                <div className="h-5 w-1/3 bg-gray-200 rounded" />
                                <div className="h-10 w-2/3 bg-gray-300 rounded" />
                                <div className="h-16 w-full bg-gray-200 rounded" />
                            </div>

                            {/* Location & Date */}
                            <div className="flex flex-col gap-4 mt-4">
                                <div className="flex flex-row gap-2 items-center">
                                    <div className="h-6 w-6 bg-gray-300 rounded" />
                                    <div className="h-5 w-1/2 bg-gray-200 rounded" />
                                </div>
                                <div className="flex flex-row gap-2 items-center">
                                    <div className="h-6 w-6 bg-gray-300 rounded" />
                                    <div className="h-5 w-2/3 bg-gray-200 rounded" />
                                </div>
                            </div>
                        </div>

                        {/* Divider */}
                        <div className="w-full h-[1px] bg-gray-200" />
                    </section>

                    <section className="flex flex-col gap-20">
                        {/* Description */}
                        <div className="flex flex-col gap-3">
                            <div className="h-7 w-1/4 bg-gray-300 rounded" />
                            <div className="h-24 w-full bg-gray-200 rounded" />
                        </div>

                        {/* Gallery */}
                        <div className="flex flex-col gap-3">
                            <div className="h-7 w-1/4 bg-gray-300 rounded" />
                            <div className="h-40 w-full bg-gray-200 rounded" />
                        </div>

                        {/* Video */}
                        <div className="flex flex-col gap-3">
                            <div className="h-7 w-1/4 bg-gray-300 rounded" />
                            <div className="h-60 w-full bg-gray-200 rounded" />
                        </div>

                        {/* Map */}
                        <div className="flex flex-col gap-3">
                            <div className="h-7 w-1/4 bg-gray-300 rounded" />
                            <div className="h-64 w-full bg-gray-200 rounded" />
                        </div>

                        {/* Bottom Spacer */}
                        <div className="flex md:hidden pb-4" />
                    </section>
                </section>
            </div>

            {/* Full-width Video Section */}
            <div className="hidden md:flex w-full relative mt-20 mb-20 flex flex-col gap-4">
                <div className="w-full lg:max-w-[1230px] aspect-video bg-gray-300 rounded-[15px]" />
                <div className="h-12 w-full rounded-xl bg-gray-200" />
            </div>

            {/* Mobile Bottom Buy Button */}
            <div className="w-full h-[80px] fixed z-50 bottom-4  left-0 right-0 items-center flex justify-center pointer-events-none md:hidden">
                <div className="w-[90%] h-full rounded-full bg-gray-200" />
            </div>
        </div>
    )
}
